/**
 * Validates whether a string is in a valid email format.
 *
 * This function uses a regular expression to check if the input
 * follows common email structure rules (local-part@domain).
 *
 * Notes:
 * - The email is normalized to lowercase before validation.
 * - This checks format only, not whether the email actually exists.
 *
 * @param email - The email address to validate
 * @returns boolean
 * - true  → if the email format is valid
 * - false → if the email format is invalid
 */
export default function validateEmail(email: string) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
